import React, { Component } from 'react';
import './styles.css';
import Header from './Header';
import HeaderItem from './HeaderItem';

class ProductionFixedCostsLayout extends Component {
	render() {
		return (
			<div className="production-fixed-costs-layout">{this.props.children}</div>
		);
	}
}

Object.assign(ProductionFixedCostsLayout, {
	Header,
	HeaderItem
});

export default ProductionFixedCostsLayout;
